import { Component, OnInit } from '@angular/core';
import { IDestinatario } from 'src/app/services/DestinatarioService/destinatario.model';
import { DestinatarioService } from 'src/app/services/DestinatarioService/destinatario.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { validarPermissao } from 'src/app/core/utils/permissionScreen/permissionScreen';

@Component({
  selector: 'app-listagem-fila-destinatario',
  templateUrl: './listagem-fila-destinatario.component.html',
  styleUrls: ['./listagem-fila-destinatario.component.scss']
})
export class ListagemFilaDestinatarioComponent implements OnInit {
  destinatarios: IDestinatario[] = [];
  isLoading = false;

  constructor(
    private destinatarioService: DestinatarioService,
    private swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.getDestinatarios();
  }

  getDestinatarios(): void {
    this.isLoading = true;
    this.destinatarioService.getDestinatarios().subscribe({
      next: (res) => {
        this.destinatarios = res.Destinatarios;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.swalAlert.handleError(err, 'Erro', 'Erro ao carregar destinatários.');
      }
    });
  }

  podeEditar(): boolean {
    return validarPermissao('parametrizacaoFila', 'editar');
  }

  alterarFila(item: IDestinatario, event: Event): void {
    const select = event.target as HTMLSelectElement;
    const novoValor = select.value === 'janela';
    const descricao = novoValor ? 'Fila por Janela' : 'Fila Corrida';

    select.value = item.FL_FILA_JNLA ? 'janela' : 'corrida';

    this.swalAlert.showAlert(
      'Confirmar alteração',
      `Deseja alterar "${item.NM_DTNR}" para ${descricao}?`,
      'warning',
      true,
      true,
      undefined,
      () => {
        this.destinatarioService.patchFilaDestinatario(item.PK_DTNR, novoValor).subscribe({
          next: () => {
            this.swalAlert.showAlert('Sucesso!', 'Tipo de fila atualizado.', 'success', true);
            this.getDestinatarios();
          },
          error: (err) => {
            this.swalAlert.handleError(err, 'Erro', 'Não foi possível atualizar o tipo de fila.');
          }
        });
      }
    );
  }
}
